import React, { useState } from "react";
import api, { formatApiError } from "../../api";
import { fmtScore, label } from "../../labels";
import AssessmentForm from "./AssessmentForm";

function Row({ a, student, onChange }) {
  const [editing, setEditing] = useState(false);
  const [err, setErr] = useState("");
  const isDraft = a.status === "draft";
  const toggle = async () => {
    if (!isDraft && !window.confirm("¿Pasar a borrador? Dejará de ser visible para el alumno y la familia.")) return;
    try {
      await api.patch(`/assessments/${a.id}`, { status: isDraft ? "published" : "draft" });
      onChange();
    } catch (ex) {
      setErr(formatApiError(ex));
    }
  };
  if (editing) {
    return <AssessmentForm student={student} initial={a} onSaved={() => { setEditing(false); onChange(); }} onCancel={() => setEditing(false)} />;
  }
  return (
    <div className="p-4 rounded-2xl bg-white border border-[#132C44]/10" data-testid={`eid-asm-row-${a.id}`}>
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div className="flex gap-1.5 flex-wrap items-center text-[11px]">
          <span className={`px-2 py-0.5 rounded-full font-semibold uppercase tracking-wider ${isDraft ? "bg-[#B08D3C]/15 text-[#7d6224]" : "bg-[#8AA986]/25 text-[#4F6B47]"}`} data-testid={`eid-asm-status-${a.id}`}>
            {label(a.status)}
          </span>
          <span className="text-[#132C44]/60">{a.date} · {label(a.skill)} · {label(a.activityType)}</span>
        </div>
        <div className="flex gap-3 text-[12px] font-semibold">
          <button onClick={() => setEditing(true)} className="hover:underline" data-testid={`eid-asm-edit-${a.id}`}>Editar</button>
          <button onClick={toggle} className={isDraft ? "text-[#4F6B47] hover:underline" : "text-[#7d6224] hover:underline"} data-testid={`eid-asm-toggle-${a.id}`}>
            {isDraft ? "Publicar" : "Pasar a borrador"}
          </button>
        </div>
      </div>
      <div className="mt-2 font-semibold text-[14px]">{a.criterion}</div>
      <div className="text-[13px] flex gap-3 flex-wrap mt-0.5">
        {fmtScore(a) && <span>Nota: <strong>{fmtScore(a)}</strong></span>}
        {(a.qualitative || a.rubricLevel) && <span className="text-[#4F6B47]">{a.qualitative || label(a.rubricLevel)}</span>}
      </div>
      {a.comment && <p className="text-[12px] text-[#132C44]/75 mt-1">{a.comment}</p>}
      {a.internalNote && (
        <p className="text-[12px] mt-2 px-2 py-1 rounded bg-[#F6EFDF]" data-testid={`eid-asm-internal-${a.id}`}>
          <strong>Interna:</strong> {a.internalNote}
        </p>
      )}
      {err && <div className="text-[12px] text-[#9B2C3B] mt-1">{err}</div>}
    </div>
  );
}

export default function AssessmentList({ assessments, student, onChange }) {
  const [filter, setFilter] = useState("all");
  const rows = assessments.filter((a) => filter === "all" || a.status === filter);
  return (
    <div className="space-y-3">
      <div className="flex gap-2 text-[12px]">
        {["all", "draft", "published"].map((k) => (
          <button key={k} onClick={() => setFilter(k)} className={`px-3 py-1 rounded-full border ${filter === k ? "bg-[#132C44] text-[#F6EFDF] border-[#132C44]" : "border-[#132C44]/20"}`} data-testid={`eid-asm-filter-${k}`}>
            {k === "all" ? "Todas" : k === "draft" ? "Borradores" : "Publicadas"}
          </button>
        ))}
      </div>
      {rows.map((a) => <Row key={a.id} a={a} student={student} onChange={onChange} />)}
      {!rows.length && <p className="text-[13px] text-[#132C44]/60">Sin evaluaciones.</p>}
    </div>
  );
}
